import { Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import Button from "../common/Button";
import TextArea from "antd/es/input/TextArea";
import { ToastFailed, ToastSuccess } from "../common/Toast";
import { apiCreateEquipment } from "../../services/Equipment";
import { onBlurInputFormData } from "../../helps/InputData";
import { apiDetailSite } from "../../services/Site";

export default ({ setPageIndex,
    isModalOpen,
    setIsModalOpen,
    handleGetListEquipments,
    siteId,
    setIsOpenModalSettingSite,
    setDataDetail,
}) => {
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        name: "",
        power: "",
        remark: ""
    })
    const [errors, setErrors] = useState({
        name: "",
        power: "",
        errRes: ""
    });

    const handleCancel = async() => {
        if (siteId) {
            const responseDetailSite = await apiDetailSite(siteId)
            if (responseDetailSite?.header?.resultCode === "1000") {
                setDataDetail(responseDetailSite?.records?.site)
            }
            setIsOpenModalSettingSite(true)
        }
        setIsModalOpen(false);
        setFormData({})

    };

    useEffect(() => {
        if (isModalOpen) {
            setFormData({
                name: "",
                power: "",
                remark: ""
            })
            setErrors({
                name: "",
                power: "",
                errRes: ""
            })
        }
    }, [isModalOpen])

    const handleChangeInput = (e, name) => {
        const newFormData = { ...formData };
        newFormData[name] = e.target.value
        setFormData(newFormData)
        setErrors({ ...errors, [name]: "", errRes: "" })
    }

    const handleCreateEquipment = async () => {
        const newErrors = {
            name: formData.name.trim() ? "" : "Name is required field.",
            power: formData.power.trim() ? "" : "Power is required field.",
        };
        setErrors(newErrors);
        if (!formData.name || !formData.power) {
            return
        }
        let newFormData = { ...formData }
        if (siteId) {
            newFormData = { ...formData, siteId }
        }
        try {
            setLoading(true)
            const response = await apiCreateEquipment({ ...newFormData, name: formData.name.trim(), power: formData.power.trim(), remark: formData.remark.trim() })
            if (response?.header?.resultCode === "1000") {

                if (siteId) {
                    const responseDetailSite = await apiDetailSite(siteId)
                    if (responseDetailSite?.header?.resultCode === "1000") {
                        setDataDetail(responseDetailSite?.records?.site)
                    }
                    setIsOpenModalSettingSite(true)
                } else {
                    setPageIndex(1)
                }
                handleCancel()
                handleGetListEquipments()
                ToastSuccess("Equipment created successfully.")
            }
        } catch (error) {
            if (error.response) {
                // Access the response object in the error
                if (error.response.data.header?.message?.includes("is exist.")) {
                    setErrors({ ...errors, errRes: "This equipment already exists in the system." })
                    ToastFailed("This equipment already exists in the system.");
                } else {
                    ToastFailed("Equipment created failed.")
                }
            } else {
                // Handle other unexpected errors
                ToastFailed("Something went wrong, please try again!");
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal title={"New equipment"} open={isModalOpen} footer={null} className='modal-add-new'>
            <div className="add-new-data">
                <div>
                    <div className="d-flex gap-2">
                        <label>Name <span className="text-danger ms-1">*</span></label>
                        <Input
                            value={formData.name}
                            placeholder="Input name"
                            className={`${errors.name || errors.errRes ? 'input-error' : ''} w-100`}
                            onChange={(e) => handleChangeInput(e, "name")}
                            onBlur={() => onBlurInputFormData({ formData, setFormData, field: "name" })}
                            maxLength={50} />
                    </div>
                    {errors.name && <div className="text-danger text-error">{errors.name}</div>}
                </div>
                <div>
                    <div className="d-flex gap-2">
                        <label>Capacity <span className="text-danger  ms-1">*</span></label>
                        <Input
                            value={formData.power}
                            placeholder="Input power"
                            className={`${errors.power || errors.errRes ? 'input-error' : ''} w-100`}
                            onChange={(e) => handleChangeInput(e, "power")}
                            onBlur={() => onBlurInputFormData({ formData, setFormData, field: "power" })}
                            maxLength={30} />
                    </div>
                    {errors.power && <div className="text-danger text-error">{errors.power}</div>}
                    {errors.errRes && <div className="text-danger text-error">{errors.errRes}</div>}
                </div>
                <div className="d-flex gap-2">
                    <label className="remark">Remark</label>
                    <TextArea rows={3}
                        placeholder="Input remark"
                        value={formData.remark}
                        onChange={(e) => handleChangeInput(e, "remark")}
                        onBlur={() => onBlurInputFormData({ formData, setFormData, field: "remark" })}
                        maxLength={500} />
                </div>
            </div>
            <div className="modal-add-new_footer">
                <Button title={"Save"} width={"62px"} handleClick={handleCreateEquipment} loading={loading} />
                <Button title={"Cancel"} BgColor={"#fff"} fontColor={"#000000D9"} borderColor={"#D9D9D9"} handleClick={handleCancel} width={"75px"} />
            </div>
        </Modal>
    );
};
